import { IGetFuncionarioImageByIdUseCase } from "../../../presentation/useCases/read/get_funcionario_image_by_id_use_case";
import { IRhRepository } from "../../repositories/rh_repository";

/**
 * GetFuncionarioImageByIdUseCase
 */

export class GetFuncionarioImageByIdUseCase implements IGetFuncionarioImageByIdUseCase {
  constructor(private readonly repository: IRhRepository) { }

  async getFuncionarioImageById(
    idFuncionario: number,
  ): Promise<string> {
    const results = await this.repository.getFuncionarioImageById(idFuncionario);
    const url = window.URL.createObjectURL(results);
    return url;
  }
}
